import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getTransaction } from '../../redux/services/balanceSlice';
import Table from '../../common/Table';
import { toast } from 'react-toastify';
import fallbackCopyText from '../../common/copyToText';
import { exportToTablePDF } from '../../common/PdfFormat';

const Transaction = () => {
    const dispatch = useDispatch();
    const getTransactionData = useSelector((state) => state?.balance?.transactionData);
     const [page, setPage] = useState(0);
      const [filter, setFilter] = useState("");
      const limitOptions = [
        { value: 10, label: 10 },
        { value: 30, label: 30 },
        { value: 50, label: 50 },
        { value: 100, label: 100 },
      ];
      const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
    const getAllTransaction = useCallback(async () => {
      try {
        await dispatch(
          getTransaction({page: page + 1, limit: pageLimit, transactionStatusFilter:filter })
        );
      } catch (error) {}
    }, [dispatch,page,pageLimit,filter]);
  
    useEffect(() => {
      getAllTransaction();
    }, [getAllTransaction]);
    const filterOptions = [
      { value: "", label: "All" },
      { value: "pending", label: "Pending" },
      { value: "success", label: "Success" },
      { value: "verified", label: "Verified" },
    ];
    const columns = [
        {
          header: "S/N",
          key: "index",
          render: (_, __, index) => index + 1,
        },
      {
              header: "Copy ID",
              key: "copy",
            render: (_, row) => (
              <button
                className="py-1 px-3 rounded-lg text-white bg-[#e0731a] font-semibold"
                onClick={() => {
                  if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard
                      .writeText(row?._id)
                      .then(() => {
                        toast.success("ID copied to clipboard!", {
                          autoClose: 2000,
                          pauseOnHover: false,
                        });
                      })
                      .catch((err) => {
                        fallbackCopyText(row?._id);
                      });
                  } else {
                    fallbackCopyText(row?._id);
                  }
                }}
              >
                Copy
              </button>
            ),
          },
        { header: "title", key: "title",
          render: (_, row) => row?.title || "-",
         },
        { header: "status", key: "transactionStatus",
          render: (_, row) => row?.transactionStatus || "-",
         },
         {
          header: "Amount",
          key: "amount",
          render: (_, row) =>
            row?.amount === 0
              ? "0"
              : row?.amount
              ? Number(row.amount).toFixed(2)
              : "-",
        }
      ];
      const exportToPDF = () => {
        const headersConfig = [
          {
            label: "S/N",
            key: "index",
            render: (_, __, index) => index + 1,
          },
          { label: "title", key: "title",
            render: (_, row) => row?.title || "-",
           },
          { label: "status", key: "transactionStatus",
            render: (_, row) => row?.transactionStatus || "-",
           },
           {
            label: "Amount",
            key: "amount",
            render: (_, row) =>
              row?.amount === 0
                ? "0"
                : row?.amount
                ? Number(row.amount).toFixed(2)
                : "-",
          }
        ];
        const data = getTransactionData?.transaction_data || [];
        exportToTablePDF({
          tableName: "Transaction Data",
          data,
          headersConfig,
          pdfName: "transaction_data.pdf",
        });
      };
  return (
    <div>
     <Table
        title="Transaction"
        columns={columns}
        data={getTransactionData?.transaction_data}
        pageCount={getTransactionData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        filterOptions={filterOptions}
        selectedFilter={filter}
        onFilterChange={(e) => setFilter(e ? e.value : "")}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
    </div>
  )
}

export default Transaction
